"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientsStore = void 0;
const api_1 = require("client/api");
const router_1 = require("client/components/router");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/dashboard/store");
const store_2 = require("client/modules/dashboard/store");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/users/store");
const mobx_1 = require("mobx");
const moment = require("moment");
const ramda_1 = require("ramda");
class PatientsStore {
    constructor() {
        this.patient = {};
        this.patients = { value: [] };
        this.orders = {};
        this.submission = {};
        this.submitted = false;
        this.parsedRows = [];
        this.importedPatients = [];
        this.selectedRowIndex = 0;
        this.importColumnsHeader = [
            "thi    s",
            "l    ist",
            "is",
            "f   or",
            "test  ing",
            "patien t "
        ];
        this.massPercent = 0;
        // C-097 Patients 
        this.totalProviderPage = 1;
        this.currentPage = 1;
        this.patientsLoading = false;
        this.mergePatientsRelations = async (mergePatientsMeta) => {
            this.patient = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.patient.value
            };
            const response = await api_1.PatientEndpoint.mergepatientsrelations.apiCall(null, mergePatientsMeta);
            if (api_1.isError(response)) {
                this.patient = {
                    error: response.code,
                    status: ui_1.FormStatus.Error,
                    value: ramda_1.merge(this.patient.value, mergePatientsMeta.currentPatient)
                };
            }
            else {
                this.patient = {
                    status: ui_1.FormStatus.Saved,
                    value: ramda_1.merge(mergePatientsMeta.currentPatient, response.patient)
                };
            }
        };
        this.loadSimilarPatients = async (query) => {
            const response = await api_1.PatientEndpoint.listsimilarpatients.apiCall({
                query
            });
            if (api_1.isError(response)) {
                console.error("Error in loading similar patients", response.code);
                return [];
            }
            return response.patients;
        };
        // C-097 Patients
        this.loadPatients = async (query = { page: 1, limit: 25 }) => {
            // this.patients.loading = true; //Ayush comment this code
            this.patientsLoading = true; // C-097 Patients
            const result = await api_1.PatientEndpoint.list.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.patients = { error: result.code };
            }
            else {
                this.patients = { value: result.patients };
                this.totalProviderPage = result.totalPages; // C-097 Patients
                this.currentPage = result.currentPage; // C-097 Patients 
            }
            this.patientsLoading = false; // C-097 Patients 
        };
        this.updateAssetsExpDate = async (uploads) => {
            console.log("uploads patients store", uploads);
            const result = await api_1.PatientEndpoint.updateassetsexpdate.apiCall(null, {
                uploads
            });
            if (api_1.isError(result)) {
                console.error("Error updating assets expiration dates in patientsStore");
            }
            else {
                console.info("Successfully updated assets expiration dates in patientsStore");
            }
        };
        this.resetWaterfall = async (patientId) => {
            const result = await api_1.PatientEndpoint.resetwaterfall.apiCall(null, {
                patientId
            });
            if (api_1.isError(result)) {
                console.log("Error in reseting patient waterfall", result.code);
                return null;
            }
            return result.patient;
        };
        this.loadOrders = async (query = { start: 0, count: 100 }) => {
            const result = await api_1.PatientEndpoint.listorders.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.orders = { error: result.code };
            }
            else {
                this.orders = { value: result.orders };
            }
        };
        // Slightly refactored Create Patient Action so that if the Sync boolean
        // is true we will pass that to the server-side endpoint.
        this.createPatient = async (patient, sync = false, insurance = null) => {
            this.patient = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.patient.value
            };
            let result;
            result = await api_1.PatientEndpoint.create.apiCall(null, {
                patient,
                sync,
                insurance
            });
            if (api_1.isError(result)) {
                this.patient = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: ramda_1.merge(this.patient.value, patient)
                };
                return false;
            }
            else {
                this.patient = {
                    status: ui_1.FormStatus.Saved,
                    value: ramda_1.merge(patient, result.patient)
                };
                return result.patient;
            }
        };
        this.readPatientSubmission = async (patient) => {
            this.patient = {
                loading: true,
                status: ui_1.FormStatus.Loading,
                value: this.patient.value
            };
            const result = await api_1.PatientEndpoint.read.apiCall({
                params: { id: patient.id }
            });
            if (api_1.isError(result)) {
                this.patient = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.patient.value
                };
                return false;
            }
            else {
                const status = result.patient.sites.length === patient.sites.length
                    ? ui_1.FormStatus.Clean
                    : ui_1.FormStatus.Dirty;
                this.patient = {
                    status,
                    value: ramda_1.merge(result.patient, patient)
                };
                return ramda_1.merge(result.patient, patient);
            }
        };
        /**
         * INSURANCE INFORMATION: Already returns active insurance as part of the object.
         * this was intentionally done so our insurances in claims wont need much changing.
         */
        this.readPatient = async (id) => {
            this.patient = {
                loading: true,
                status: ui_1.FormStatus.Loading,
                value: this.patient.value
            };
            const result = await api_1.PatientEndpoint.read.apiCall({
                params: { id }
            });
            if (api_1.isError(result)) {
                this.patient = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.patient.value
                };
                return false;
            }
            else {
                this.patient = { status: ui_1.FormStatus.Clean, value: result.patient };
                return result.patient;
            }
        };
        this.readNewPatient = async (patient) => {
            this.patient = { value: ramda_1.merge(this.patient, patient) };
            return patient;
        };
        /**
         * INSURANCE: The patient object DOES NOT include insurance infromation, to save
         * insurance it must be passed as a paramater of .savePatient.
         */
        this.savePatient = async (patient, insurance) => {
            this.patient = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.patient.value
            };
            // console.log("saving patient triggered");
            // console.log("Patient is ", patient);
            // console.log("insurance is ", insurance);
            const result = await api_1.PatientEndpoint.save.apiCall(null, {
                patient,
                insurance
            });
            if (api_1.isError(result)) {
                this.patient = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: ramda_1.merge(this.patient.value, patient)
                };
                return false;
            }
            else {
                this.patient = {
                    status: ui_1.FormStatus.Saved,
                    value: ramda_1.merge(patient, result.patient)
                };
                return result.patient;
            }
        };
        /**
         * INSURANCE: This needs to flag all insurance objects as deleted at.
         */
        this.deletePatient = async (patient) => {
            const result = await api_1.PatientEndpoint.remove.apiCall({
                params: { id: patient.id }
            });
            if (api_1.isError(result)) {
                this.patients = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.patients.value
                };
                return false;
            }
            else {
                return true;
            }
        };
        this.undeletePatient = async (patient) => {
            const result = await api_1.PatientEndpoint.recover.apiCall({
                params: { id: patient.id }
            });
            if (api_1.isError(result)) {
                this.patients = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.patients.value
                };
                return false;
            }
            else {
                return true;
            }
        };
        this.loadPatientMini = async (siteId) => {
            const result = await api_1.PatientEndpoint.listMini.apiCall({
                params: { siteId }
            });
            if (api_1.isError(result)) {
                this.patients = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.patients.value
                };
                return false;
            }
            else {
                return true;
            }
        };
        this.reset = () => {
            this.submission = {};
            this.submitted = false;
        };
        this.import = async (files, siteId) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newPatient", file, file.name);
            });
            formData.append("siteId", siteId);
            let response = await api_1.PatientEndpoint.parse.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
                return;
            }
            response = await api_1.PatientEndpoint.submit.apiCall(null, {
                // this will save an object with an array of patient objects and the siteId.
                patients: response.patients,
                siteId
            });
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
            }
        };
        this.parse = async (files, siteId) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newPatient", file, file.name);
            });
            formData.append("siteId", siteId);
            const response = await api_1.PatientEndpoint.parse.apiCall(null, formData);
            // console.log("response is ", response);
            try {
                if (response.patients) {
                    this.parsedPatients = { patients: response.patients, siteId };
                }
            }
            catch (e) {
                console.log("an error caught from parse: ", e);
            }
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
            }
            else {
                this.submission = { value: response.patients };
            }
        };
        this.parseImportsHeader = async (files) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newPatient", file, file.name);
            });
            const response = await api_1.PatientEndpoint.parseColumnsHeader.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code };
                throw Error("error in parsing");
            }
            else {
                this.parsedRows = response.parsedRows;
            }
        };
        this.submit = async (siteId) => {
            this.submission = { loading: true, value: this.submission.value };
            if (!this.submission.value) {
                this.submission = {};
                return;
            }
            const response = await api_1.PatientEndpoint.submit.apiCall(null, {
                patients: this.submission.value,
                siteId
            });
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
            }
        };
        this.submitUserMappedPatientsHeader = async (mappedPatients, siteId) => {
            this.submission = { loading: true, value: mappedPatients };
            if (!this.submission.value) {
                this.submission = {};
                return;
            }
            const response = await api_1.PatientEndpoint.submit.apiCall(null, {
                patients: this.submission.value,
                siteId
            });
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
            }
        };
        this.uploadStartAlert = async () => {
            const { accepted, sitesIds } = this.importedFileAndSitesIds;
            const sitesInfo = await store_3.sitesListStore.loadSpecificSites(sitesIds);
            const siteNames = sitesInfo.map(site => `Pharmacy Name: ${site.displayName}</br>`);
            const fileNameMetas = accepted.map(file => {
                const { name: fileName, size: fileSize, type: fileType } = file;
                return `
        File name: ${fileName}
        </br>
        File size: ${fileSize}
        </br>
        File type: ${fileType}
        </br>
      `;
            });
            const message = `
      <div class="patient-insert-alert">
        Patient upload is processing.
        </br>
        ${fileNameMetas}
        Number of patients: ${this.submission.value && this.submission.value.length
                ? this.submission.value.length
                : 0}
        <br />
        Clinic ids: ${sitesIds.join(", ")}
        <br />
        ${siteNames}
        Start time: ${moment(new Date()).format("M/D/YYYY hh:mm:ss")}
        <br />
        <br />
        Another alert will notify you when the upload is finished.
      </div>
     `;
            const userId = store_4.usersStore &&
                store_4.usersStore.user &&
                store_4.usersStore.user.value &&
                store_4.usersStore.user.value.id
                ? store_4.usersStore.user.value.id
                : null;
            let siteName = "";
            for (const siteId of sitesIds) {
                const siteInfo = sitesInfo.filter(site => site.id === siteId);
                const siteName = siteInfo[0].displayName;
                const alert = {
                    subject: `(${siteName}) Patient upload: PROCESSING`,
                    message,
                    alertType: store_1.AlertType.Null,
                    siteId,
                    userId
                };
                await store_2.dashboardStore.createAlert(alert);
            }
            const logData = {
                action: `${siteName} Patient upload: PROCESSING`,
                category: store_4.LogCategory.schedule,
                site: Number(sitesIds[0]),
                user: userId
            };
            await store_4.usersStore.createLog(logData);
        };
        this.uploadEndAlert = async (erroredPatients) => {
            const shouldRenderErrorPatients = erroredPatients && erroredPatients.length;
            const renderErrorPatients = () => {
                const re = /[^\s\w@\-*&]+/gi;
                return erroredPatients
                    .map(errPatient => `${errPatient.parameters
                    .map(parameter => parameter.replace(re, ""))
                    .join(" ")} <br />`)
                    .join("");
            };
            const messageDone = `
    <div class="patient-insert-alert">
      Patient upload complete.
      <br />
      End time: ${moment(new Date()).format("M/D/YYYY hh:mm:ss")}
      <br />
      <br />
      ${shouldRenderErrorPatients
                ? `The following patients data contain errors (These patients were not created): <br />`
                : ""}
      ${shouldRenderErrorPatients ? renderErrorPatients() : ""}
    </div>
   `;
            const userId = store_4.usersStore &&
                store_4.usersStore.user &&
                store_4.usersStore.user.value &&
                store_4.usersStore.user.value.id
                ? store_4.usersStore.user.value.id
                : null;
            // console.log("messageDone", messageDone);
            const { sitesIds } = this.importedFileAndSitesIds;
            const sitesInfo = await store_3.sitesListStore.loadSpecificSites(sitesIds);
            // luvSolution
            let siteName = "";
            for (const siteId of sitesIds) {
                const siteInfo = sitesInfo.filter(site => site.id === siteId);
                const siteName = siteInfo[0].displayName;
                const alertDone = {
                    subject: `(${siteName}) Patient upload: COMPLETED`,
                    message: messageDone,
                    alertType: store_1.AlertType.Null,
                    siteId,
                    userId
                };
                await store_2.dashboardStore.createAlert(alertDone);
            }
            const logData = {
                action: `${siteName} Patient upload: COMPLETED`,
                category: store_4.LogCategory.schedule,
                site: Number(sitesIds[0]),
                user: userId
            };
            await store_4.usersStore.createLog(logData);
        };
        this.uploadErrorAlert = async () => {
            const messageError = `
    <div class="patient-insert-alert">
      Patient upload ERROR OCCURRED.
      <br />
      End time: ${moment(new Date()).format("M/D/YYYY hh:mm:ss")}
    </div>
   `;
            const userId = store_4.usersStore &&
                store_4.usersStore.user &&
                store_4.usersStore.user.value &&
                store_4.usersStore.user.value.id
                ? store_4.usersStore.user.value.id
                : null;
            const { sitesIds } = this.importedFileAndSitesIds;
            const sitesInfo = await store_3.sitesListStore.loadSpecificSites(sitesIds);
            for (const siteId of sitesIds) {
                const siteInfo = sitesInfo.filter(site => site.id === siteId);
                const siteName = siteInfo[0].displayName;
                const alertDone = {
                    subject: `(${siteName}) Patient upload: Error occured"`,
                    message: messageError,
                    alertType: store_1.AlertType.Null,
                    siteId,
                    userId
                };
                await store_2.dashboardStore.createAlert(alertDone);
            }
        };
        this.normalizeDob = (date) => {
            if (!date) {
                return "";
            }
            const dateFormats = [
                "M/D/YY",
                "YYYY-MM-DD",
                "M/D/YYYY",
                "MM/D/YYYY",
                "MM/DD/YYYY",
                "YYYY-MM-DDH:mm A",
                "YYYY-MM-DDH:mm:ss",
                "YYYY-MM-DDH:mm:ss A"
            ];
            // Check for two digits format
            const twoDigitsFormat = "M/D/YY";
            const isTwoDigitsFormat = moment(date, twoDigitsFormat, true).isValid(); /*?*/
            const momentDate = moment(date, dateFormats);
            let normalizedDob = "";
            if (isTwoDigitsFormat) {
                normalizedDob = momentDate.isAfter()
                    ? momentDate.format("19YY-MM-DD")
                    : momentDate.format("YYYY-MM-DD");
            }
            else {
                if (momentDate.isValid()) {
                    normalizedDob = momentDate.format("YYYY-MM-DD");
                }
            }
            return normalizedDob;
        };
        this.submitPatientsImportToManySites = async (mappedPatients, sitesIds) => {
            this.submission = { loading: true, value: mappedPatients };
            if (!this.submission.value) {
                this.submission = {};
                return;
            }
            await this.uploadStartAlert();
            api_1.PatientEndpoint.submittomanysites
                .apiCall(null, {
                patients: this.submission.value,
                sitesIds
            })
                .then(async (response) => {
                if (api_1.isError(response)) {
                    await this.uploadErrorAlert();
                    this.submission = {
                        error: response.code,
                        value: this.submission.value
                    };
                }
                else {
                    await this.uploadEndAlert(response.erroredPatients);
                    this.submission = { value: this.submission.value };
                    this.submitted = true;
                }
            })
                .catch(e => {
                console.log("error in inserting patients", e);
            });
            router_1.RouteManager.transitionTo("/dashboard");
        };
        this.futureRefills = async (orderId) => {
            const response = await api_1.PatientEndpoint.futureRefills.apiCall(null, {
                orderId
            });
            if (api_1.isError(response)) {
                console.log("Error encountered.");
            }
            else {
                return Promise.all(response.refills);
            }
        };
        this.patientSync = async (patientsArray, siteName) => {
            const response = await api_1.PatientEndpoint.massCreatePatient.apiCall(null, {
                patientsArray,
                siteName
            });
            return response;
        };
        // Uploads Section
        this.upload = async (files, patientId, uploadType) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newFile", file);
            });
            formData.append("patientId", patientId);
            formData.append("uploadType", uploadType);
            const response = await api_1.PatientEndpoint.uploadFile.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
                router_1.RouteManager.transitionTo(`patients/${patientId}`);
            }
        };
        this.updateAssetsDescriptions = async (uploads) => {
            console.log("uploads patientsstore", uploads);
            const result = await api_1.PatientEndpoint.updateassetsdescriptions.apiCall(null, { uploads });
            if (api_1.isError(result)) {
                console.error("Error updating assets descriptions in patientsstore");
            }
            else {
                console.info("Successfully updated assets descriptions in patientsstore");
            }
        };
        this.deleteAsset = async (uploadId, patientId) => {
            const result = await api_1.PatientEndpoint.removeFile.apiCall({
                params: { upload: uploadId }
            });
            if (api_1.isError(result)) {
                this.patients = {
                    error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: this.patients.value
                };
                return false;
            }
            else {
                this.readPatient(patientId);
                return true;
            }
        };
        this.syncInsuranceReqeust = () => {
            // Nice Reqeust!
            api_1.PatientEndpoint.syncInsuranceRequest.apiCall();
        };
        this.massInsuranceRequest = async (patients) => {
            const total = patients.length;
            let finished = 0;
            for (const patient of patients) {
                await this.insuranceRequest(patient).then(() => {
                    finished++;
                    this.massPercent = Math.floor((finished / total) * 100);
                });
            }
        };
        this.insuranceDelete = async (insuranceId) => {
            const result = await api_1.PatientEndpoint.insuranceDelete.apiCall(null, {
                insuranceId
            });
            return result;
        };
        /**
         * The below Method is for sending a request for an individual patient
         */
        this.insuranceRequest = async (patient) => {
            this.patient = {
                loading: true,
                status: ui_1.FormStatus.Saving,
                value: this.patient.value
            };
            // console.log("patient in store is", patient);
            // Need to set up data to be passed to server
            const result = await api_1.PatientEndpoint.insuranceRequest.apiCall(null, {
                patient
            });
            if (api_1.isError(result)) {
                this.patient = {
                    // error: result.code,
                    status: ui_1.FormStatus.Error,
                    value: ramda_1.merge(this.patient.value, patient)
                };
                return false;
            }
            this.patient = {
                status: ui_1.FormStatus.Saved,
                value: ramda_1.merge(patient, result.patient)
            };
            return result.patient;
        };
    }
}
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "patient", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "patients", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "orders", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "submission", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "submitted", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "parsedRows", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "mappedHeadersObject", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "parsedPatients", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "importedPatients", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "databaseColumnsHeader", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "selectedRowIndex", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "importedFileAndSiteId", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "importedFileAndSitesIds", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "importColumnsHeader", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "claim", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "massPercent", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "insurance", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "totalProviderPage", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "currentPage", void 0);
__decorate([
    mobx_1.observable
], PatientsStore.prototype, "patientsLoading", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "mergePatientsRelations", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "loadSimilarPatients", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "loadPatients", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "updateAssetsExpDate", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "resetWaterfall", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "loadOrders", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "createPatient", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "readPatientSubmission", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "readPatient", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "readNewPatient", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "savePatient", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "deletePatient", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "undeletePatient", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "loadPatientMini", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "reset", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "import", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "parse", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "parseImportsHeader", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "submit", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "submitUserMappedPatientsHeader", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "uploadStartAlert", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "uploadEndAlert", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "uploadErrorAlert", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "normalizeDob", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "submitPatientsImportToManySites", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "futureRefills", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "upload", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "updateAssetsDescriptions", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "deleteAsset", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "syncInsuranceReqeust", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "massInsuranceRequest", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "insuranceDelete", void 0);
__decorate([
    mobx_1.action
], PatientsStore.prototype, "insuranceRequest", void 0);
exports.patientsStore = new PatientsStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/store.ts
// module id = 141
// module chunks = 0